import { useRmwPaths } from '@zg-rentals/rental-manager-env';
import React from 'react';
import { useLocation } from 'react-router-dom';

export const useActiveTab = () => {
  const location = useLocation();
  const paths = useRmwPaths();

  return React.useMemo(() => {
    const tabName = location.pathname.split('/')[3];
    switch (tabName) {
      case paths.userManagementUsers:
        return paths.userManagementUsers;
      case paths.userManagementActivity:
        return paths.userManagementActivity;
      case paths.userManagementPending:
        return paths.userManagementPending;
      case paths.userManagementApplicationPermissions:
        return paths.userManagementApplicationPermissions;
      case paths.userManagementUnrecognizedUsers:
        return paths.userManagementUnrecognizedUsers;
      default:
        return paths.userManagementUsers;
    }
  }, [location, paths]);
};
